import FolderIcon from '../assets/icons/folder.svg?react';
import PdfIcon from '../assets/icons/pdf.svg?react';
import ExcelIcon from '../assets/icons/excel.svg?react';
import { REPORT_TYPES } from './reportTypes';

export const fileTypes = {};

export const SPREADSHEET_FILE_ACCEPT =
  'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv,.xlsx,.xls,.xlsm';

export const PDF_EXTRACTION_FILE_ACCEPT = `${SPREADSHEET_FILE_ACCEPT},application/pdf,.pdf`;

export const SPREADSHEET_DROPZONE_ACCEPT = {
  'text/csv': ['.csv'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm']
};

// A conversion is one Excel workbook, read by the name of a sheet inside it — a CSV has no sheets.
export const WORKBOOK_FILE_ACCEPT =
  'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx,.xls,.xlsm';

export const WORKBOOK_DROPZONE_ACCEPT = {
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm']
};

export const PDF_EXTRACTION_DROPZONE_ACCEPT = {
  ...SPREADSHEET_DROPZONE_ACCEPT,
  'application/pdf': ['.pdf']
};

export const workflowSupportsPdfExtraction = reportType =>
  [REPORT_TYPES.ANNEX_IV, REPORT_TYPES.FORM_PF].includes(reportType);

export const getWorkflowFileAccept = reportType =>
  workflowSupportsPdfExtraction(reportType) ? PDF_EXTRACTION_FILE_ACCEPT : SPREADSHEET_FILE_ACCEPT;

export const getWorkflowDropzoneAccept = reportType =>
  workflowSupportsPdfExtraction(reportType)
    ? PDF_EXTRACTION_DROPZONE_ACCEPT
    : SPREADSHEET_DROPZONE_ACCEPT;

// The same set as the accept string above (plus images), in the map form the cloud browser
// matches on: what you can import must equal what you can upload from the device.
export const SOURCE_FILE_DROPZONE_ACCEPT = {
  'text/csv': ['.csv'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp']
};

export const fileIcons = {
  folder: FolderIcon,
  excel: ExcelIcon,
  csv: ExcelIcon,
  xlsx: ExcelIcon,
  xls: ExcelIcon,
  word: ExcelIcon,
  pdf: PdfIcon
};
